import classNames from 'classnames'
import moment from 'moment-timezone'

import { useGetDashUnitStats } from '@apps-common/apis/portal/dash'
import { PageSubtitle } from '@apps-common/components/common/portal-title'
import { UNIT_STATUS_ACTIVE, UNIT_STATUS_INACTIVE } from '@apps-common/config/unit-filter'
import { useNavigation } from '@apps-common/hooks/useNavigation'
import { AUTH_CLAIMS, useAuthorizationCheckAccess } from '@apps-common/lib'
import {
  DEFAULT_MANAGEMENT_UNITS_FILTER_STORE_PROPS,
  DEFAULT_PORTAL_UNITS_FILTER_STORE_PROPS,
  useManagementUnitsFilterStore,
  usePortalUnitsFilterStore
} from '@apps-common/stores'
import { ROUTE_UNITS } from '@apps-radionet-portal-root/src/config/private-routes'

export const TotalActiveKpiCard = () => {
  const { navigateRoot } = useNavigation()
  const hasManagementAccess = useAuthorizationCheckAccess({
    roles: AUTH_CLAIMS.managementAdmin.roles,
    scopes: AUTH_CLAIMS.managementAdmin.scopes
  })
  const { setTempState: setPortalTempState } = usePortalUnitsFilterStore()
  const { setTempState: setManagementTempState } = useManagementUnitsFilterStore()
  const { isLoading, data } = useGetDashUnitStats({})

  return (
    <button
      type='button'
      className='bg-surface border border-border w-full h-[100%] rounded-3xl overflow-hidden ring-1 ring-info'
      onClick={() => {
        if (hasManagementAccess) {
          setManagementTempState({
            ...DEFAULT_MANAGEMENT_UNITS_FILTER_STORE_PROPS,
            status: UNIT_STATUS_ACTIVE.value as string
          })
          navigateRoot({ routeUrl: ROUTE_UNITS.buildPath(), route: ROUTE_UNITS })
        } else {
          setPortalTempState({
            ...DEFAULT_PORTAL_UNITS_FILTER_STORE_PROPS,
            status: UNIT_STATUS_ACTIVE.value as string
          })
          navigateRoot({ routeUrl: ROUTE_UNITS.buildPath(), route: ROUTE_UNITS })
        }
      }}
    >
      <div className='relative z-[1] pt-4 pb-3 px-4 md:p-8 md:pb-7 flex flex-col h-[100%]'>
        <PageSubtitle classes='text-text text-right'>
          <span className='text-[0.9em]'>Total active</span>
          <br />
        </PageSubtitle>
        <div className='grow flex items-center justify-center'>
          <div
            className={classNames(
              'min-w-[70px] px-4 py-2 bg-surface-2 rounded-full flex items-center justify-center text-text',
              isLoading && 'animate-pulse'
            )}
          >
            <h4 className='text-[1.5rem] sm:text-[1.95rem] md:text-[2.5rem] jost-medium'>
              {!isLoading && data ? new Intl.NumberFormat().format(data?.totalActive || 0) : <span>&nbsp;</span>}
            </h4>
          </div>
        </div>
        <div className='flex items-center justify-between'>
          <div
            className={classNames(
              'bg-surface-2 rounded-full px-2 py-[3px] xl:py-[8px] jost-light inline w-auto text-[0.7em] md:text-[0.8em] text-text',
              (isLoading || !data) && 'animate-pulse'
            )}
          >
            <span className={classNames('flex gap-[3px]', (isLoading || !data) && 'opacity-0')}>
              <div className='hidden xl:inline-block'>As at </div>
              {moment.utc(data?.timestamp).local().format('DD/MM/YYYY')}
            </span>
          </div>
          {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions */}
          <div
            className={classNames(
              'relative flex items-center justify-start bg-surface-2 rounded-full gap-[3px] p-[2px] pr-[5px] lg:pr-[0px] right-[6px] xs:right-[0px] scale-[68%] xl:scale-100',
              (isLoading || !data) && 'animate-pulse'
            )}
            onClick={(e) => {
              e?.stopPropagation()
              if (hasManagementAccess) {
                setManagementTempState({
                  ...DEFAULT_MANAGEMENT_UNITS_FILTER_STORE_PROPS,
                  status: UNIT_STATUS_INACTIVE.value as string
                })
                navigateRoot({ routeUrl: ROUTE_UNITS.buildPath(), route: ROUTE_UNITS })
              } else {
                setPortalTempState({
                  ...DEFAULT_PORTAL_UNITS_FILTER_STORE_PROPS,
                  status: UNIT_STATUS_INACTIVE.value as string
                })
                navigateRoot({ routeUrl: ROUTE_UNITS.buildPath(), route: ROUTE_UNITS })
              }
            }}
          >
            <div className={classNames('bg-surface-2 rounded-full jost-medium px-[8px] py-[3px]', (isLoading || !data) && 'opacity-0')}>
              {data?.totalInactive || '0'}
            </div>
            <span className={classNames('jost-light', (isLoading || !data) && 'opacity-0')}>Inactive</span>
          </div>
        </div>
      </div>
      {/* <div className='absolute w-full h-full top-0 left-0 bg-secondary/70 rounded-3xl z-[0]' /> */}
    </button>
  )
}
